module.exports = __webpack_public_path__ + "static/img/introductionTitle.441b6037.png";